import { Slider, Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import React, { useState, useContext } from "react";
import { ColorTheme } from "../../../../TypesAndConstants/const";
import { randomColorIndex } from "../../../../TypesAndConstants/colorPalette";
import { Context } from "../../../../Context/context";
import ModeSwitch from '../ModeSwitch'
const useStyles = makeStyles((theme) => ({
  activeBorder: {
    transform: "scale(1.1)",
    boxShadow: "2px 1px 4px",
  },
  blockContainer: {
    fontFamily: "'amatic', cursive",
    height: "30vh",
    float: "right",
    padding: "10px",
    overflowY: "auto",
  },
  centerContent: {
    backgroundColor:'black',
    display: "flex",
    justifyContent: "center",
  },
  displayContainer: {
    padding: "20px",
    height: "300px",
    width: "250px",
  },
  buttonContainer: {
    marginTop: "22px",
    display: "flex",
    justifyContent: "space-around",
  },
  colorBlocks: {
    display: "grid",
  },
  colorPalette: {
    height: "75px",
    width: "25px",
    display: "inline-block",
    margin: "5px",
  },
  display: {
    width: "auto",
    height: "50px",
  },
  mainContainer: {},
  randomColor: {
    width: "100%",
    borderTopRightRadius: "4px",
    borderTopLeftRadius: "4px",
    fontFamily: "'amatic', cursive",
    background: ColorTheme.contrastBackground,
    boxShadow:
      "inset 0 1px 1px #fff, inset 0 -1px 1px #aaa, 0 2px 4px -3px #666",
    "&:hover": { boxShadow: "inset 0 1px 1px #aaa, inset 0 -1px 1px #aaa" },
  },
}));

interface Props {
  palettes: string[][];
  setVariations: (index: number) => void;
  variations: number;
  handlePaletteClick: (index: number) => void;
  setRandomColor: () => void;
}

export default React.memo(function PaletteMenu(props: Props) {
  const {
    palettes: colorPalettes,
    setVariations,
    handlePaletteClick,
    variations,
    setRandomColor,
  } = props;
  const { state, dispatch: mDispatch } = useContext(Context);
  // const { dispatch } = useContext(ColorContext);

  const [activeColor, setActiveColor] = useState<number>(-1);
  const [isRandom, setIsRandom] = useState<boolean>(!state.isPaletteUsed);
  const styles = useStyles();

  const handleModeChange = ( random: boolean )=>{
    setIsRandom( random )
    if( random ){
      setRandomColor()
    }
    mDispatch( { type: "set_palette_used", value: !random } )
  }

  const handleVariations = (
    event: Event,
    value: number | number[],
    activeThumb: number
  ) => {
    event.preventDefault();
    setVariations(value as any);
  };

  const setColorSpeed = (
    event: Event,
    value: number | number[],
    activeThumb: number
  ) => {
    mDispatch({ type: "set_color_speed", value: value });
  };

  const colorSquare = (colors: string[], index: number) => {
    return (
      <div
        className={activeColor === index ? styles.activeBorder : ""}
        key={index}
        onClick={() => {
          setIsRandom(false);
          setActiveColor(index);
          handlePaletteClick(index);
        }}
        style={{
          height: "75px",
          width: "25px",
          display: "inline-block",
          margin: "5px",
        }}
      >
        {colors.map((i: string, ind: number) => {
          return (
            <div
              key={i + index + ind}
              style={{ background: i, width: "100%", height: "15px" }}
            ></div>
          );
        })}
      </div>
    );
  };

  return (
    <div>
      <div className={styles.colorBlocks}>
        <div
          style={{ width: "100%", alignItems: "center", textAlign: "center" }}
        ></div>
        <div style={{ padding: "3px" }}>
          <div>
            <p
              style={{
                fontFamily: "amatic",
                fontSize: "2rem",
                margin: "0",
              }}
            >
              Color Change Speed:
            </p>
            <Slider
              aria-labelledby="discrete-slider-small-steps"
              onChange={setColorSpeed}
              min={0.01}
              max={0.25}
              step={0.01}
              valueLabelDisplay="auto"
              value={state.colorTransitionSpeed}
            />
          </div>
        </div>
        <div style={{ padding: "10px", boxShadow: "4px 4px 10px" }}>
          <ModeSwitch onModeChange={handleModeChange} defaultValue={isRandom} 
              onMenuLabel={"Random"} 
              className={`${styles.centerContent}`}
              offMenuLabel={"Palettes"} />
          {isRandom ? (
            <div
              style={{ padding: "3px", display: isRandom ? "block" : "none" }}
            >
              <div>
                <p
                  style={{
                    fontFamily: "amatic",
                    fontSize: "2rem",
                    margin: "0",
                  }}
                >
                  Variations:
                </p>
                <Slider
                  aria-labelledby="discrete-slider-small-steps"
                  onChange={handleVariations}
                  min={2}
                  max={100}
                  step={1}
                  valueLabelDisplay="auto"
                  value={variations}
                />
              </div>
            </div>
          ) : (
            <div className={styles.blockContainer}>
              {colorPalettes.map((i: string[], index) => {
                return colorSquare(i, index);
              })}
            </div>
          )}
        </div>
      </div>
    </div>
  );
});
